import dataLayer from '@anwb/poncho/utilities/data-layer';

type EventTypes = {
	event: string;
	component?: string;
	category?: string;
	type?: string;
	field?: string;
	action?: string;
	actionValue?: string;
	text?: string;
	position?: string;
	status?: string;
	personalisation?: string;
	variant?: string;
	product?: string;
	ecommerce?: unknown | null;
	funnel_name?: string;
	funnel_step?: string;
	funnel_index?: string;
};

/**
	This function will push a data layer event in the format wanted by Google Analytics 4.
	We can't use the formDataLayer function from @anwb/data-layer because it misses the variant prop.

	@param event An object representing the event
 */
export const trackEvent = (event: EventTypes): void => dataLayer(event);
